{
    "Title": "Manage Queues",
    "ManageQueuesDescriptionTitle": "Description",
    "ManageQueuesCQConfigurationsTitle": "CQ Configurations",
    "ManageQueuesResourceAccountsTitle": "Resource Accounts",
    "ManageQueuesMonitoringStatusTitle": "Monitoring Status",
    "ManageQueueFiltersTitle": "Filters",
    "ManageQueueCallMonitoringHistoric": "Historic",
    "ManageQueueCallMonitoringRealTime": "Real-Time",
    "ManageQueueCallMonitoringRealTimeForced": "Real-Time (Forced)",
    "ManageQueueCallMonitoringUnknown": "Unknown",
    "ManageQueueCallCQConfigurationCompatible": "Compatible",
    "ManageQueueCallCQConfigurationIncompatible": "Incompatible",
    "ManageQueuesQueueFilterAll": "All Queues",
    "ManageQueuesFilterCompatible": "Compatible Queues",
    "ManageQueuesFilterIncompatible": "Incompatible Queues",
    "ManageQueue_DisableEnableRealtime_Confirm": "Confirm",
    "ManageQueue_DisableEnableRealtime_Cancel": "Cancel",
    "ManageQueue_MonitorAllMessage": "Are you sure you want to enable real-time monitoring for all queues?",
    "ManageQueue_UnmonitorAllMessage": "Are you sure you want to disable real-time monitoring for all queues?",
    "ManageQueue_Loading_Monitoring_All": "Enabling real-time monitoring for all queues",
    "ManageQueue_Loading_Unmonitoring_All": "Disabling real-time monitoring for all queues",
    "ManageQueue_Pending_Queue_Disabling": "Disabling monitoring...",
    "ManageQueue_Pending_Queue_Enabling": "Enabling monitoring...",
    "ManageQueue_Disable_RT_Popper": "Disable Real-Time monitoring on all Queues",
    "ManageQueue_Enable_RT_Popper": "Enable Real-Time monitoring on all Queues",
    "ManageQueues_Not_Found_Error": "No queues matching that search were found",
    "ManageQueues_Linkage_Title": "Linked Resource Accounts / Voice Apps",
    "ManageQueues_Linkage_Help": "Click Help to find out how to relink Resource Accounts",
    "ManageQueues_Linkage_Types_CallQueue": "Resource account '**{}**' is used for '**{}**' exception handling on Call Queue '**{}**'.",
    "ManageQueues_Linkage_Types_AutoAttendant": "Resource account '**{}**' is used for option '**{}**' of '**{}**' on Auto Attendant '**{}**'.",
    "ManageQueues_Linkage_Types_Policy": "Resource account '**{}**' is used within policy '**{}**' of type '**{}**'.",
    "ManageQueues_Linkage_CallQueue_Exceptions_overflow": "Overflow",
    "ManageQueues_Linkage_CallQueue_Exceptions_timeout": "Timeout",
    "ManageQueues_Linkage_CallQueue_Exceptions_noagent": "No Agent",
    "ManageQueues_Linkage_CallQueue_Exceptions_obo": "On Behalf Of",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_businesshours": "Business Hours",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_afterhours": "After Hours",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_holiday": "Holiday",
    "ManageQueues_Linkage_Policy_Types_teamssharedcallingroutingpolicy": "Shared Calling Routing Policy",
    "ManageQueues_Linkage_Policy_Types_teamsunassignednumbertreatment": "Unassigned Number Treatment",
    "ManageQueues_Linkage_Policy_Types_callinglineidentity": "Calling Line Identity",
    "ManageQueues_Linkage_Options_automatic": "Redirect",
    "ManageQueues_Linkage_Options_pound": "Pound",
    "ManageQueues_Linkage_Options_star": "Star",
    "ManageQueues_Linkage_NoInfo": "No resource account references for this queue.",
    "ManageQueues_Incompatibility_Popup_Title": "Incompatible Settings",
    "ManageQueues_ExchangePermission_Error": "User Admin/Exchange Permission not found against the TelSys Auth User. Shared Voicemails cannot be created.",
    "NAME": "ManageQueues"
}
